export type RawResolutionType = 'FIN' | 'VIN' | 'REGISTRATION_PLATE';
export type ResolutionType = 'fin' | 'vin' | 'licensePlate';

export const resolutionTypeMap = {
  FIN: 'fin',
  VIN: 'vin',
  REGISTRATION_PLATE: 'licensePlate',
};
